import _ from 'lodash';
import React from 'react';
import { Header, Grid, Icon, Form, Divider } from 'semantic-ui-react';
import {
    TextBoxField,
    InlineSelect,
    RadioField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import { ROLE_MAP_INTERNAL } from 'go/components/organization/team/constants';

const SearchFilterSort = ({
    userData,
    filters,
    handleFilterChange,
    clearFiltersAndReset,
    sortField,
    setSortField,
    sortDir,
    setSortDir
}) => {

    const roles = _.uniq(_.map(_.flatMap(_.map(userData, u => u.roles)), r => _.get(r, 'roleId')));

    const entities = _.uniqBy(_.flatMap(_.map(_.flatMap(_.map(userData, u => u.roles)), r => _.map(r.entities, e => ({ ...e, entityTypeId: _.get(r,'entityTypeId') })))), 'entityName');

    return (
        <Form>
            <Grid doubling stackable reversed="mobile" padded="vertically">
                <Grid.Column width={10}>
                    <Header as="h3">Search</Header>
                </Grid.Column>
                <Grid.Column width={6} textAlign="right">
                    <Icon name="undo" color="blue" size="small" />
                    <a
                        id="clearSearch"
                        className="table-link"
                        onClick={clearFiltersAndReset}
                    >
                        Clear
                    </a>
                </Grid.Column>
            </Grid>
            <TextBoxField
                key="teamMemberName"
                title="Search by Team Member Name"
                name="teamMemberName"
                label="Search by Name"
                id="teamMemberName"
                value={_.get(filters, 'name', '')}
                handleChange={(e) => handleFilterChange('name', e.target.value)}
            />
            <TextBoxField
                key="teamMemberEmail"
                title="Search by Team Member Email Address"
                name="teamMemberEmail"
                label="Search by Email Address"
                id="teamMemberEmail"
                value={_.get(filters, 'emailAdr', '')}
                handleChange={(e) => handleFilterChange('emailAdr', e.target.value)}
            />
            <Divider />
            <Header as="h3">Filter by</Header>
            <InlineSelect
                key="rolesSelect"
                id="role"
                label="Role"
                labeled="true"
                search
                selection
                title="Filter by member Role"
                name="roleSelection"
                value={_.get(filters, 'roleId', '')}
                options={[{ key: 'role0', value: '', text: '' }, ..._.orderBy(_.map(roles, roleId => ({ key: `role${roleId}`, value: roleId, text: ROLE_MAP_INTERNAL[roleId] })), 'text')]}
                handleChange={(e) => handleFilterChange('roleId', e.target.value)}
            />
            <InlineSelect
                key="categorySelect"
                id="category"
                label="Level Category"
                labeled="true"
                search
                selection
                title="Filter by category"
                name="categorySelection"
                value={_.get(filters, 'entity', '')}
                options={[{ key: 'category0', value: '', text: '' }, ..._.orderBy(_.map(entities, entity => ({ key: `category-${entity.entityTypeId}-${entity.entityId}`, value: `${entity.entityTypeId}:${entity.entityId}`, text: entity.entityName })), 'text')]}
                handleChange={(e) => handleFilterChange('entity', e.target.value)}
            />
            <Divider />
            <Header as="h3">Sort</Header>
            <InlineSelect
                key="teamMemberSortBySelect"
                search
                selection
                title="Sort"
                name="sortBy"
                id="sortBy"
                label="Sort by"
                value={sortField}
                options={[
                    {
                        key: 'lastName',
                        value: 'lastName',
                        text: 'Last Name',
                    },
                    { key: 'emailAdr', value: 'emailAdr', text: 'Email' },
                ]}
                handleChange={(e) => setSortField(e.target.value)}
            />
            <Form.Field>
                <RadioField
                    key="sortDir"
                    name="sortDir"
                    value={sortDir}
                    options={[
                        { label: 'Ascending (A-Z)', value: 'asc' },
                        { label: 'Descending (Z-A)', value: 'desc' },
                    ]}
                    handleChange={(e) => setSortDir(e.target.value)}
                />
            </Form.Field>
        </Form>
    )
}

export default SearchFilterSort;